import {
  Injectable
} from '@angular/core';


import {BehaviorSubject} from 'rxjs';
import {ApiService} from '../api';
import {UserContext} from '../user-context';
import {HttpParams} from '@angular/common/http';
import {UserInfo} from '../../models';

@Injectable()

export class BrandService extends BehaviorSubject<any> {

  constructor() {
    super({});
  }

}
